export const SET_RECORD = "setRecord";
export const SET_RECORDS = "setRecords";
